// https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
// https://en.wikipedia.org/wiki/ISO_639-1
const SUPPORTED_ISO_639_1_CODES = ["en", "sv", "de", "lv", "ru", "it"] as const;
const DEFAULT_ISO_639_1_CODE = "en" as const;

export const retrieveBrowserLocale = () => {
  const browserLocale =
    // This corresponds to the user's top selected browser language.
    navigator.language;

  return retrieveLocale(browserLocale);
};

export const retrieveHardcodedLocale = (locale: string) => {
  return retrieveLocale(locale);
};

const retrieveLocale = (locale: string) => {
  const matchingSupportedTopLevelLanguageCode = SUPPORTED_ISO_639_1_CODES.find(
    (supportedTopLevelLanguageCode) =>
      // Users often have `en-US` or similar selected.
      locale.startsWith(supportedTopLevelLanguageCode),
  );
  return matchingSupportedTopLevelLanguageCode ?? DEFAULT_ISO_639_1_CODE;
};
